module.exports = __webpack_public_path__ + "media/stylesheets/images/main/kakao_symboli_brown-a3a2c2c47b3024134b47bc214da27ad9.png";